module.exports = __webpack_public_path__ + "static/media/questionmark.9f3b13c6.png";